<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="card">
        <div class="card-body">
          <form
            @submit.prevent="submit()"
            :class="{ 'disabled-form': disabled }"
          >
            <div class="p-2">
              <div class="mb-3">
                <label class="form-label" for="date">Date</label>
                <DateInput
                  id="date"
                  name="date"
                  placeholder="Enter Date"
                  type="text"
                  class="form-control"
                  v-model="updatedDistributorInvoice.date"
                  :disabled="disabled"
                />
              </div>
              <div class="mb-3">
                <label class="form-label" for="distributor">Supplier</label>
                <div class="col-sm-auto col-md">
                  <select
                    class="form-select"
                    v-model="updatedDistributorInvoice.distributorID"
                    placeholder="Select Supplier"
                    :disabled="disabled"
                  >
                    <option value="" selected>Select Supplier</option>
                    <option
                      v-for="value in distributors"
                      :key="value.id"
                      :value="value.id"
                    >
                      {{ value.company }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label" for="category">Memo/Invoice No</label>
                <input
                  id="invoiceNo"
                  name="invoiceNo"
                  placeholder="Enter Memo/Invoice No"
                  class="form-control"
                  v-model="updatedDistributorInvoice.invoiceNo"
                  :disabled="disabled"
                />
              </div>

              <div class="mb-3">
                <label class="form-label" for="amount"> Amount Purchase </label>
                <input
                  placeholder="Enter Amount Purchase"
                  v-model="updatedDistributorInvoice.amountPurchase"
                  type="number"
                  step="0.01"
                  class="form-control"
                  :disabled="disabled"
                />
              </div>

              <div class="mb-3">
                <label class="form-label" for="category">Note</label>
                <input
                  id="note"
                  name="note"
                  placeholder="Enter Note"
                  type="text"
                  class="form-control"
                  v-model="updatedDistributorInvoice.note"
                  :disabled="disabled"
                />
              </div>

              <div class="hstack gap-2 mt-4">
                <button v-if="!disabled" type="submit" class="btn btn-primary">
                  Save
                </button>
                <button
                  v-if="disabled"
                  type="button"
                  class="btn btn-primary"
                  @click="edit"
                >
                  Edit
                </button>
                <button type="button" class="btn btn-light" @click="discard">
                  Back
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateInput from "@/components/utils/DateInput";

export default {
  name: "DistributorInvoicesForm",
  components: { DateInput },
  props: {
    distributorInvoice: {
      type: Object,
      required: true,
    },
    submitFunction: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      updatedDistributorInvoice: { ...this.distributorInvoice },
    };
  },
  methods: {
    submit() {
      if (!this.disabled) {
        Object.keys(this.updatedDistributorInvoice).forEach((key) => {
          let value = this.updatedDistributorInvoice[key];

          // Remove null or empty string values
          if (value === null || value === "") {
            delete this.updatedDistributorInvoice[key];
          }

          // Ensure invoiceNo is cast to string
          if (key === "invoiceNo" && value !== null && value !== undefined) {
            this.updatedDistributorInvoice[key] = String(value);
          }
        });

        this.submitFunction(this.updatedDistributorInvoice);
      }
    },
    discard() {
      this.updatedDistributorInvoice = { ...this.distributorInvoice };
      this.$router.push("/distributors/invoices/");
    },
    edit() {
      this.$router.push(
        "/distributors/invoices/edit/" + this.distributorInvoice.id
      );
    },
  },
  computed: {
    disabled() {
      return typeof this.submitFunction !== "function";
    },
    distributors() {
      return this.$store.getters.allDistributors;
    },
  },
  async created() {
    let filter = {
      resultsPerPage: 100,
    };
    await this.$store.dispatch("getDistributors", filter);
  },
};
</script>

<style scoped>
select:disabled {
  background-color: #fff;
  color: #999;
  cursor: not-allowed;
}
</style>
